import { Collection, util } from '@glu/core';
import FieldSearch from './fieldSearch';
import template from './textSearch.hbs';

function filterableColumns(column) {
  return column.get('filterable') !== false;
}

export default FieldSearch.extend({
  template,

  initialize(...args) {
    FieldSearch.prototype.initialize.apply(this, args);
    if (this.options.model) {
      this.setField(this.options.model.get('field'));
    }
  },

  serializeData() {
    let items;
    if (this.model && this.collection) {
      items = new Collection(this.collection.filter(filterableColumns));
      const obj = this.model.toJSON();
      obj.items = items.toJSON();
      return obj;
    }

    if (this.collection) {
      items = new Collection(this.collection.filter(filterableColumns));
      return {
        items: items.toJSON()
      };
    }
    return FieldSearch.prototype.serializeData.call(this);
  },

  handleSubmit(e) {
    e.preventDefault();

    const filter = this.createFilter();

    try {
      this.trigger('filter', filter);
    } catch (ex) {
      return false;
    }

    return false;
  },

  createFilter() {
    return this.buildFilter(this.model.get('field'), this.ui.$focusField.val());
  },

  buildFilter(field, value) {
    return {
      title: this.model.get('title'),
      label: value,
      value,
      type: this.model.get('type') || 'string',
      field: field || this.model.get('field'),
      filter: util.bind(this.filter, this, this.field || field, value)
    };
  },

  onRender(...args) {
    FieldSearch.prototype.onRender.apply(this, args);

    if (this.field && this.collection && this.collection.length > 0) {
      const { field } = this;
      const opt = this.ui.$fieldSelect.find(`option[value='${field}']`);
      opt.attr('selected', 'selected');
    }
  },

  setField(field) {
    this.field = field;
    this.className = this.className || 'field-set';
  },

  unsetField() {
    delete this.field;
  },

  filter(field, value, model) {
    let modelVal = model.get(field);

    if (util.isNumber(modelVal) || util.isString(modelVal)) {
      modelVal = (`${modelVal}`).toLowerCase(); // make sure numbers are searched as strings
    } else {
      return false; // model does not have that field in a searchable form
    }

    if (util.isString(value) || util.isNumber(value)) {
      value = (`${value}`).toLowerCase();
    }

    return modelVal.indexOf(value) > -1;
  }
});
